import { useSettingsStore } from '@/state/useSettingsStore'
import type { DashboardSnapshot } from '@/data/types'

const STATUS_COLOR: Record<'ok' | 'warn' | 'error', string> = {
  ok: 'bg-[color:var(--signal-good)]',
  warn: 'bg-[color:var(--signal-warn)]',
  error: 'bg-[color:var(--signal-bad)]',
}

export function ServiceHealthStrip({ services }: { services: DashboardSnapshot['serviceHealth'] }) {
  const locale = useSettingsStore((s) => s.locale)

  if (services.length === 0) return null

  return (
    <section className="flex items-center gap-4 rounded-2xl border border-border bg-surface-1/70 px-5 py-3">
      <h3 className="shrink-0 text-xs uppercase tracking-[0.18em] text-ink-subtle">
        {locale === 'cs' ? 'Stav služeb' : 'Service status'}
      </h3>
      <div className="flex flex-1 flex-wrap items-center gap-3">
        {services.map((svc) => (
          <div
            key={svc.name}
            className="flex items-center gap-2 rounded-xl border border-border/80 bg-surface-2/60 px-3 py-1.5"
            title={`${svc.callsLast24h} ${locale === 'cs' ? 'volání za 24h' : 'calls in 24h'}`}
          >
            <span className={`size-2 shrink-0 rounded-full ${STATUS_COLOR[svc.status]}`} />
            <span className="text-sm font-medium text-ink">{svc.name}</span>
            <span className="text-xs tabular-nums text-ink-subtle">{svc.avgLatencyMs} ms</span>
          </div>
        ))}
      </div>
    </section>
  )
}
